import { Directive } from '@angular/core';
import { SourceSystemType } from '../foundation/models/enums/source-system-type.enum';
import { BaseComponent } from '../shared/base-components/base.component';
import { DriverRouteBuilderService } from '../shared/services/route-builder/driver-route-builder.service';

@Directive()
export abstract class DriverBaseComponent extends BaseComponent {
    private _routeBuilder: DriverRouteBuilderService;
    private sourceSystemTypes: SourceSystemType = new SourceSystemType();

    // DRIVER_TODO: What is the difference between these?
    public saving: boolean;
    public waiting: boolean;
    protected loaded: boolean;

    constructor() {
        super();
    }

    /**
     * Gets the route builder for Driver
     */
    public get routeBuilder(): DriverRouteBuilderService {
        if (this._routeBuilder == undefined) {
            let trRouteBuilder: any = this.routeBuilderFactory.create(this.sourceSystemTypes.Driver.id);
            this._routeBuilder = trRouteBuilder;
        }

        return this._routeBuilder;
    }
}
